import { render } from "./MyModal.vue?vue&type=template&id=0a385798&scoped=true"
import script from "./MyModal.vue?vue&type=script&lang=js"
export * from "./MyModal.vue?vue&type=script&lang=js"

import "./MyModal.vue?vue&type=style&index=0&id=0a385798&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a385798"]])

export default __exports__